import React from "react";

import PerformanceIndicatorArrow from "../PerformanceIndicatorArrow/PerformanceIndicatorArrow";
import Text from "../Typography/Text";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import toPercent from "@src/utils/toPercent";

import styles from "./TextWithPerformance.module.css";

interface Props {
  numberText?: string | number;
  isPercent?: boolean;
}

const TextWithPerformance: React.FC<Props> = ({ numberText, isPercent }) => {
  if (numberText === undefined) {
    return (
      <div className={styles.container}>
        <div className={styles.text}>- -</div>
      </div>
    );
  }

  const value = Number(numberText);

  let notAvailable = false;
  if (isNaN(value)) {
    notAvailable = true;
  }

  const isPositive = value >= 0;

  return (
    <div className={styles.container}>
      {notAvailable ? (
        <Text variant="body" color="textSubtle">
          {"N/A"}
        </Text>
      ) : (
        <>
          <PerformanceIndicatorArrow
            status={!isPositive ? "negative" : "positive"}
          />

          <div
            className={toClassName(styles.text, {
              [styles.positive]: isPositive,
              [styles.negative]: !isPositive,
            })}
          >
            {`${isPositive ? "+" : ""}${
              isPercent ? toPercent(value) : numberText
            }`}
          </div>
        </>
      )}
    </div>
  );
};

export default TextWithPerformance;
